import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Taluka from "./Taluka";
import TalukaDetailspage from "./TalukaDetailspage";
import { getTalukaDataSync } from "../../../utils/talukaCache";

const TalukaRouteWrapper = () => {
  const { url } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Data is already fetched and patched in App.js via talukaCache
    const cachedData = getTalukaDataSync();
    if (cachedData) {
      setData(cachedData);
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <div className="text-center py-5">Loading...</div>;
  }

  // Check if url matches a city url
  const isCity = data.find((city) => city.url === url);
  if (isCity) {
    return <Taluka cityData={isCity} allData={data} />;
  }

  // Check if url matches a taluka url
  let foundTaluka = null;
  let parentCity = null;
  for (const city of data) {
    const taluka = city.talukas.find((t) => t.url === url);
    if (taluka) {
      foundTaluka = taluka;
      parentCity = city;
      break;
    }
  }

  if (foundTaluka) {
    return <TalukaDetailspage talukaData={foundTaluka} parentCity={parentCity} />;
  }

  // Fallback to Taluka main page with default city if not found, or maybe just 404
  return <Taluka allData={data} />;
};

export default TalukaRouteWrapper;
